import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid, Typography } from "@material-ui/core";
import { cargarEstadisticas } from "../../../actions/miOspedyc/estadisticasMiOspedyc";
import { ESTADISTICAS_OSPEDYC } from "../../../utils/constants";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1rem",
        marginBottom: "1rem"
    },
    iframe: {
        width: "100%",
        height: "100vh"
    },
    title: {
        fontWeight: "bold",
        marginBottom:"1rem"
    },
}));

export const Farmacias = (props) => {

    const classes = useStyles();
    const dispatch=useDispatch()

    useEffect(() => {
        dispatch(cargarEstadisticas(ESTADISTICAS_OSPEDYC.FARMACIAS))
        // eslint-disable-next-line
    }, [])
    return (
        <div className={classes.root}>
            <Container maxWidth="lg">
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                >
                    <Grid item xs={12}>
                        <Typography align="center" variant="h4" color="primary" className={classes.title}>Farmacias</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <iframe
                            id="inlineFrameExample"
                            title="Ospedyc-Farmacias"
                            className={classes.iframe}
                            src={process.env.REACT_APP_URL + "/documentos-mobile/Farmacias/ospedyc-farmacias.pdf"}>
                        </iframe>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};
